module.exports = __webpack_public_path__ + "img/empty-outbox.120960e6.svg";